<div class="w-100-p padding-10-lr padding-12-b scroll-y h-60">
  @let view = viewOutput;
  @if (alert()) {
    <div class="clr-row nxm clr-justify-content-center clr-align-items-baseline">
      <clr-alert class="clr-col-md-8 clr-col" clrAlertType="warning" [clrAlertClosable]="false">
        <clr-alert-item class="clr-align-items-baseline">
          <span class="alert-text">
            {{ 'Zuerst müssen ' + (alert() | titlecase) + ' eingetragen werden' | mrTranslate }}
          </span>
          @if (alert() == 'zähler') {
            <button class="btn btn-icon btn-outline" (click)="openVerwaltung()">
              <cds-icon shape="cog" [title]="'Zählerverwaltung öffnen' | mrTranslate" />
            </button>
          } @else {
            <div class="alert-actions">
              <a (click)="view.emit(alert())" class="alert-action">
                {{ 'Gehen zu ' + (alert() | titlecase) | mrTranslate }}
              </a>
            </div>
          }
        </clr-alert-item>
      </clr-alert>
    </div>
  } @else {
    <div class="clr-row nm clr-justify-content-center">
      <div class="btn-group margin-12-tb">
        <button
          type="button"
          class="btn btn-primary"
          [clrLoading]="saveState()"
          [disabled]="!selectedMasken().length || !selectedZaehler()"
          (click)="editZuordnung(selectedZaehler().ID)">
          {{ 'Zuweisen' | mrTranslate }} {{ selectedZaehler()?.Code }}
        </button>
        <button
          type="button"
          class="btn btn-danger"
          [clrLoading]="saveState()"
          [disabled]="!selectedMasken().length"
          (click)="editZuordnung(null)">
          {{ 'Zuweisung löschen' | mrTranslate }}
        </button>
        <button class="btn btn-icon btn-outline" (click)="openVerwaltung()">
          <cds-icon shape="cog" [title]="'Zählerverwaltung öffnen' | mrTranslate" />
        </button>
      </div>
    </div>
    <div class="clr-row nm h-60">
      <div class="clr-col-6 h-100">
        @if (maskenTable(); as masken) {
          <clr-datagrid
            class="datagrid-compact h-100"
            [clrDgSelectionType]="'multi'"
            [clrDgSelected]="selectedMasken()"
            (clrDgSelectedChange)="selectedMasken.set($event)"
            [clrDgItemsIdentityFn]="row => row?.ID">
            <clr-dg-column clrDgField="ID">
              <ng-container *clrDgHideableColumn="{ hidden: true }">ID</ng-container>
            </clr-dg-column>
            <clr-dg-column clrDgField="Name">{{ 'Maske' | mrTranslate }}</clr-dg-column>
            <clr-dg-column clrDgField="SZAEHNID">
              <ng-container *clrDgHideableColumn="{ hidden: true }">SZAEHNID</ng-container>
            </clr-dg-column>
            <clr-dg-column clrDgField="Code">{{ 'Zählerprogramme' | mrTranslate }}</clr-dg-column>
            <clr-dg-row *clrDgItems="let row of masken.rows" [clrDgItem]="row">
              <clr-dg-cell>{{ row.ID }}</clr-dg-cell>
              <clr-dg-cell>{{ row.Name }}</clr-dg-cell>
              <clr-dg-cell>{{ row.SZAEHNID }}</clr-dg-cell>
              <clr-dg-cell>{{ row.Code }}</clr-dg-cell>
            </clr-dg-row>

            <ng-template let-detail [clrIfDetail]="maskeDetail()" (clrIfDetailChange)="maskeDetail.set($event)">
              <clr-dg-detail>
                <clr-dg-detail-header>
                  <span>{{ detail.Name }}</span>
                </clr-dg-detail-header>
                <clr-dg-detail-body>
                  @if (maskeItems(); as items) {
                    <h3>{{ 'Wartungsarten in Maske' | mrTranslate }}</h3>
                    <div class="padding-24-t">
                      <div class="border-table h-100 scroll">
                        <table class="table margin-0-t table-compact h-100">
                          <thead style="position: sticky; top: -1px; z-index: 3">
                            <tr>
                              <th class="left">{{ 'Bezeichnung' | mrTranslate }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            @for (item of items; track item.rID) {
                              <tr [class.headerRow]="item.Typ == 0">
                                <td class="left">{{ item.Bezeichnung }}</td>
                              </tr>
                            } @empty {
                              <tr aria-hidden="true">
                                <td class="left">{{ 'Maske ist nicht konfiguriert' | mrTranslate }}</td>
                              </tr>
                            }
                          </tbody>
                        </table>
                      </div>
                    </div>
                  } @else {
                    <clr-spinner class="centred" />
                  }
                </clr-dg-detail-body>
              </clr-dg-detail>
            </ng-template>
            <clr-dg-footer>{{ masken.rows.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
          </clr-datagrid>
        } @else {
          <clr-spinner class="centred" />
        }
      </div>
      <div class="clr-col-6 h-100">
        @if (zaehlerTable(); as zaehler) {
          <clr-datagrid
            class="datagrid-compact h-100"
            [clrDgSelectionType]="'single'"
            [clrDgSelected]="[selectedZaehler()]"
            (clrDgSelectedChange)="selectedZaehler.set($event[0])"
            [clrDgItemsIdentityFn]="row => row?.ID">
            <clr-dg-column clrDgField="ID">
              <ng-container *clrDgHideableColumn="{ hidden: true }">ID</ng-container>
            </clr-dg-column>
            <clr-dg-column clrDgField="Code">{{ 'Zählerprogramme' | mrTranslate }}</clr-dg-column>
            <clr-dg-column clrDgField="Bezeichnung">{{ 'Bezeichnung' | mrTranslate }}</clr-dg-column>
            <clr-dg-column clrDgField="isSR100">
              <ng-container *clrDgHideableColumn>
                {{ 'isSR100' | transformColNames: tolOptions() }}
              </ng-container>
            </clr-dg-column>
            <clr-dg-column clrDgField="isSRG">
              <ng-container *clrDgHideableColumn>
                {{ 'isSRG' | transformColNames: tolOptions() }}
              </ng-container>
            </clr-dg-column>
            <clr-dg-row *clrDgItems="let row of zaehler.rows" [clrDgItem]="row">
              <clr-dg-cell>{{ row.ID }}</clr-dg-cell>
              <clr-dg-cell>{{ row.Code }}</clr-dg-cell>
              <clr-dg-cell>{{ row.Bezeichnung }}</clr-dg-cell>
              <clr-dg-cell><app-dg-cell [data]="row.isSR100" /></clr-dg-cell>
              <clr-dg-cell><app-dg-cell [data]="row.isSRG" /></clr-dg-cell>
            </clr-dg-row>

            <ng-template [clrIfDetail]="zaehlerDetail()" (clrIfDetailChange)="zaehlerDetail.set($event)">
              <clr-dg-detail>
                @let detail = zaehlerDetail();
                <clr-dg-detail-header>
                  <span>{{ detail.Code }}</span>
                  @if (detail.HasHelper) {
                    <button
                      class="btn btn-icon btn-outline margin-6-l"
                      [title]="'Beschreibung' | mrTranslate"
                      (click)="isHelperModalOpen.set(true)">
                      <cds-icon shape="help" />
                    </button>
                    <app-hilfe-beschreibung-modal
                      [(isModalOpen)]="isHelperModalOpen"
                      [id]="detail.ID"
                      [table]="'SZAEHN'"
                      [readonly]="true" />
                  }
                </clr-dg-detail-header>
                <clr-dg-detail-body>
                  @if (skizzeRs.hasValue()) {
                    <app-preview-thumbnails
                      [data]="[{ base64: skizzeRs.value(), name: `${detail.Bild}.png` }]"
                      [readonly]="true"
                      [isSkizze]="true" />
                  }
                  @if (zaehlerWerte(); as werte) {
                    <h3>{{ 'Zählerwerte SA' | mrTranslate }}</h3>
                    <div class="padding-24-t">
                      <div class="border-table h-100 scroll">
                        <table class="table margin-0-t table-compact h-100">
                          <thead style="position: sticky; top: -1px; z-index: 3">
                            <tr>
                              <th class="left">{{ 'Code' | mrTranslate }}</th>
                              <th class="left">{{ 'Bezeichnung' | mrTranslate }}</th>
                              <th class="left">{{ 'Soll' | mrTranslate }}</th>
                              <th class="left">{{ 'Einheit' | mrTranslate }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            @for (wert of werte.rows; track wert.ID) {
                              <tr [class.headerRow]="wert.ZType == ZType_Header">
                                <td class="left">{{ wert.Code }}</td>
                                <td class="left">{{ wert.Bezeichnung }}</td>
                                <td class="left">{{ wert.Soll }}</td>
                                <td class="left">{{ wert.Einheit }}</td>
                              </tr>
                            } @empty {
                              <tr aria-hidden="true">
                                <td class="left" colspan="4">
                                  {{ 'Zählerwerte sind nicht konfiguriert' | mrTranslate }}
                                </td>
                              </tr>
                            }
                          </tbody>
                        </table>
                      </div>
                    </div>
                  } @else {
                    <clr-spinner class="centred" />
                  }
                </clr-dg-detail-body>
              </clr-dg-detail>
            </ng-template>
            <clr-dg-footer>{{ zaehler.rows.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
          </clr-datagrid>
        } @else {
          <clr-spinner class="centred" />
        }
      </div>
    </div>
  }
</div>
